import { Component, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Request } from 'src/app/components/massive/models/request.interface';
import { RequestDataList } from 'src/app/components/massive/models/requestDataList.model';
import { RequestFilters } from 'src/app/components/massive/models/requestFilters.model';
import { Filters } from 'src/app/components/shared/types/filters.type';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { TableColumn } from 'src/app/components/shared/types/tableColumn.type';
import { MassiveRequestFlags } from '../../massive-request.flags';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { MassiveRequestActions } from '../../massive-request.actions';
import { TableOption } from 'src/app/components/massive/models/tableOption.interface';

@Component({
  selector: 'app-massive-request-table',
  templateUrl: './request-table.component.html',
  styleUrls: ['./request-table.component.sass'],
})
export class RequestTableComponent {
  @Input() dataList: RequestDataList;
  @Input() flags: Flags<MassiveRequestFlags>;
  @Input() tableListColumns: TableColumn<Request, RequestFilters>[];
  @Input() filters: Filters<RequestFilters>;
  @Input() tableOptionList: TableOption[] = [];
  @Input() actions: Actions<MassiveRequestActions, Request>;
  @Input() statuses: SelectItem[];

  massiveRequestFlags = MassiveRequestFlags;

  constructor() {
    /** */
  }

  getPermissionList(row: Request) {
    return { [row.id]: { edit: true, program: row.routed } };
  }
}
